import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import apiClient from '../lib/api'

export const useAcampantesStore = defineStore('acampantes', () => {
  const acampantes = ref([])
  const loading = ref(false)

  const totalCount = computed(() => acampantes.value.length)
  const pending = computed(() => acampantes.value.filter(a => !a.check))
  const confirmed = computed(() => acampantes.value.filter(a => a.check))
  const pendingCount = computed(() => pending.value.length)
  const confirmedCount = computed(() => confirmed.value.length)

  function byEquipe(equipe) {
    return acampantes.value.filter(a => a.equipe === equipe)
  }

  async function fetchAll() {
    loading.value = true
    try {
      const res = await apiClient.get('/listar')
      acampantes.value = res.data
    } finally {
      loading.value = false
    }
  }

  async function create(data) {
    const res = await apiClient.post('/cadastrar', data)
    addFromPusher(res.data.acampante)
    return res.data
  }

  async function update(id, data) {
    const res = await apiClient.patch(`/atualizar/${id}`, data)
    updateFromPusher(res.data.acampante)
    return res.data
  }

  async function remove(id) {
    await apiClient.delete(`/remover/${id}`)
    removeFromPusher(id)
  }

  async function checkin(id, { transporte }) {
    const res = await apiClient.post(`/scan/${id}`, { transporte })
    // API retorna participant atualizado (no caso de alreadyCheckedIn, ainda
    // vem o estado canônico). Sincroniza o store via dedupe.
    if (res.data.participant) updateFromPusher(res.data.participant)
    return res.data
  }

  async function uncheckin(id) {
    const res = await apiClient.post(`/uncheck/${id}`)
    if (res.data.participant) updateFromPusher(res.data.participant)
    return res.data
  }

  // Dedupe por id: usado também pelos eventos Pusher
  function addFromPusher(item) {
    if (!item || !item.id) return
    const idx = acampantes.value.findIndex(a => a.id === item.id)
    if (idx === -1) acampantes.value.push(item)
    else acampantes.value[idx] = item
  }

  function updateFromPusher(item) {
    if (!item || !item.id) return
    const idx = acampantes.value.findIndex(a => a.id === item.id)
    if (idx === -1) acampantes.value.push(item)
    else acampantes.value[idx] = item
  }

  function removeFromPusher(id) {
    acampantes.value = acampantes.value.filter(a => a.id !== id)
  }

  return {
    acampantes,
    loading,
    totalCount,
    pending,
    confirmed,
    pendingCount,
    confirmedCount,
    byEquipe,
    fetchAll,
    create,
    update,
    remove,
    checkin,
    uncheckin,
    addFromPusher,
    updateFromPusher,
    removeFromPusher
  }
})
